import { useId, type ReactNode } from "react";
import { ChevronRight } from "lucide-react";
import { Button } from "../atoms/Button/index.js";
import { hiddenExchangeSummary } from "./exchange-filter";

/**
 * Task 17 — a compact, muted disclosure standing in for one stretch of other
 * people's discussion. Expanding it reveals the original rows IN PLACE;
 * collapsing folds them again. Neither changes the filter, the transcript or
 * anyone else's view.
 */
export function HiddenExchangeRow({
  humanCount,
  aiCount,
  expanded,
  onToggle,
  children,
}: {
  humanCount: number;
  aiCount: number;
  expanded: boolean;
  onToggle: () => void;
  /** The hidden rows, rendered only while expanded. */
  children: ReactNode;
}) {
  const panelId = useId();
  return (
    <div className="min-w-0" data-hidden-exchange>
      <Button
        variant="ghost"
        size="xs"
        className="w-full justify-start"
        aria-expanded={expanded}
        aria-controls={panelId}
        onClick={onToggle}
      >
        <ChevronRight
          className={`h-3 w-3 shrink-0 transition-transform ${
            expanded ? "rotate-90" : ""
          }`}
          aria-hidden
        />
        <span className="min-w-0 truncate text-start font-normal text-pb-text-muted">
          {hiddenExchangeSummary(humanCount, aiCount)}
        </span>
      </Button>
      <div id={panelId} hidden={!expanded} className="mt-3 space-y-3">
        {expanded ? children : null}
      </div>
    </div>
  );
}
